import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import LandingPage from './pages/LandingPage'

const CreatePage = lazy(() => import('./pages/CreatePage'))
const ResultPage = lazy(() => import('./pages/ResultPage'))
const App = lazy(() => import('./App.tsx'))

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Suspense fallback={<div style={{padding:24,color:'#9ca3af',fontFamily:'system-ui,sans-serif'}}>로딩 중...</div>}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/result/:id" element={<ResultPage />} />
          <Route path="/proposal/:id" element={<ResultPage />} />
          <Route path="/builder" element={<App />} />
          <Route path="/builder/:id" element={<App />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </StrictMode>,
)
